export const haloEducationArticles = Object.freeze([
  Object.freeze({
    slug: "what-is-quantumcloak",
    eyebrow: "Meet QuantumCloak",
    title: "What is QuantumCloak?",
    summary:
      "QuantumCloak is the advanced security feature in the LightningFlow platform behind Halo SuperVPN—bringing privacy, protection and clear connection status together.",
    seoDescription:
      "Discover the advanced QuantumCloak security feature in the LightningFlow platform behind Halo SuperVPN.",
    sections: Object.freeze([
      Object.freeze({
        heading: "Less exposure. More privacy.",
        body: "QuantumCloak helps keep private services and protected connections out of unnecessary view, reducing exposure while preserving the access you choose.",
      }),
      Object.freeze({
        heading: "One seamless layer of protection.",
        body: "Halo SuperVPN brings VPN privacy, LightningFlow’s QuantumCloak security and encrypted traffic together in one remarkably simple experience.",
      }),
      Object.freeze({
        heading: "Confidence at a glance.",
        body: "Halo SuperVPN makes your protection easy to understand, with clear connection states that show when you are protected, connecting or need attention.",
      }),
    ]),
    spotlight:
      "QuantumCloak works quietly behind Halo SuperVPN, adding an advanced layer of protection to every supported connection.",
  }),
  Object.freeze({
    slug: "why-post-quantum-protection-matters",
    eyebrow: "Ready for tomorrow",
    title: "Why post-quantum protection matters",
    summary:
      "Tomorrow’s threats demand protection designed to evolve. Halo SuperVPN is built on LightningFlow, a security platform made for the long term.",
    seoDescription:
      "Learn why long-term security matters and how LightningFlow gives Halo SuperVPN a layered foundation designed to evolve.",
    sections: Object.freeze([
      Object.freeze({
        heading: "Security built for the long term.",
        body: "Encryption standards change. LightningFlow is designed so protection can advance without making security harder for the people who depend on it.",
      }),
      Object.freeze({
        heading: "Layered from the start.",
        body: "QuantumCloak combines reduced exposure, private connectivity and clear protection status, so Halo SuperVPN does not rely on a single line of defence.",
      }),
      Object.freeze({
        heading: "Progress you can trust.",
        body: "Real security is built carefully. LightningFlow advances protection through deliberate testing and review, so every improvement earns its place in Halo SuperVPN.",
      }),
    ]),
    spotlight:
      "QuantumCloak gives Halo SuperVPN a layered security foundation designed to grow stronger as the threat landscape changes.",
  }),
]);

export function findHaloEducationArticle(slug) {
  return haloEducationArticles.find((article) => article.slug === slug);
}
